require('./files-tree.component.scss');

const ICONS = {
  'application/pdf': 'icon-file-pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'icon-file-word',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'icon-file-powerpoint',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'icon-file-excel',
  'application/vnd.oasis.opendocument.text': 'icon-file-word',
  'application/vnd.oasis.opendocument.spreadsheet': 'icon-file-excel',
  'application/vnd.oasis.opendocument.presentation': 'icon-file-powerpoint',
  'application/vnd.ms-xpsdocument': 'icon-print',
  'text/plain': 'icon-doc-text',
  'inode/directory': 'icon-folder-empty',
};

const getPath = (node, path) => path == '' ? node.name : (
  path == '/' ? path + node.name : path + '/' + node.name
);

export function FileTreeComponent() {
  return {
    template: require('./files-tree.component.html'),
    scope: {
      filter: '<',
      files: '<'
    },
    controller: function($scope) {
      $scope.getPath = getPath;
    },
  };
}


export function FileTreeNodeComponent() {
  return {
    template: require('./files-tree-node.component.html'),
    scope: {
      node: '<',
      path: '<',
      filter: '<',
    },
    controller: function($scope, $element, $http, FilesTreeService) {
      $scope.FilesTreeService = FilesTreeService;
      $scope.loadNode = (node) => {
        if (node.mime == 'inode/directory') {
          node.open = !node.open;
          if (node.open) {
            $scope.FilesTreeService.load($scope.path, data => $scope.tree = data);
            // $http.get('/files/folder-' + $scope.path).then(function(response) {
            //   $scope.tree = response.data;
            // });
          } else {
            $scope.tree = [];
          }
        } else {
          let path = $scope.path;
          if (path[1] == ':') {
            path = path.replaceAll('/', '\\');
          }
          $scope.filter.filter.setFilter('agent_attachedfile@file_path:file_path', path, path);
          $scope.$emit('reload');
        }
      };

      $scope.getIcon = (node) => {
        if (node.mime == 'inode/directory') {
          return node.open ? 'icon-folder-open-empty' : 'icon-folder-empty';
        }
        return ICONS[node.mime] || 'icon-doc';
      };

      $scope.getPath = getPath;
    },
  };
}



// WEBPACK FOOTER //
// ./src/view/filetree/files-tree.component.js